import Stack from '@mui/material/Stack';

export function CustomNoRowsOverlay() {
    return (
        <Stack height="100%" alignItems="center" justifyContent="center">
            No deductions
        </Stack>
    );
}